import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import MealSubscription from '../Components/MealSubscription/MealSubscription'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function MealSubscriptionPage() { // renamed component
    return (
        <>

        <Helmet>
                <title>Veg Meal Subscription Service in Coimbatore | Tickling Tummy Plans</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing flexible weekly and monthly meal subscriptions in R.S. Puram for healthy, home-cooked food." />
                <meta name="keywords" content="Vegetarian meal subscription Coimbatore, Weekly veg meal plan, Monthly meal plan Coimbatore, Homemade veg food subscription, Lunch box service Coimbatore" />
                <link rel="canonical" href="https://ticklingtummy.com/meal-subscription" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Veg Meal Subscription Service in Coimbatore | Tickling Tummy Plans" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing flexible weekly and monthly meal subscriptions in R.S. Puram for healthy, home-cooked food." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/daily-lunch-subscription-slider.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/meal-subscription" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Veg Meal Subscription Service in Coimbatore | Tickling Tummy Plans" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, providing flexible weekly and monthly meal subscriptions in R.S. Puram for healthy, home-cooked food." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/daily-lunch-subscription-slider.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Meal Subscription",
    "item": "https://ticklingtummy.com/meal-subscription"
  }
]
        }, null, 2)}
        </script>
            <HeaderOne />
            <MealSubscription />
            <Footer />
        </>
    );
}

export default MealSubscriptionPage;
